module.exports = __webpack_public_path__ + "static/media/map.eeb91a3e.png";